import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { AppNavigationProps } from './AppNavigation';

const AppNavigation = () => import(/* webpackChunkName: "4-feat-appnavigation-phase1" */ './AppNavigation');

const LoadableAppNavigation: ComponentType<AppNavigationProps> = lazyLoadOnRender({ loader: AppNavigation });
export default LoadableAppNavigation;
